import { Page, View, Document, StyleSheet, Font } from '@react-pdf/renderer';

type Props = {
  children: React.ReactNode;
};
export function PDFGenerator({ children }: Props) {
  Font.register({
    family: 'F Grotesk',
    src: '/fonts/familjen-grotesk/familjen-grotesk-v4-latin-regular.ttf'
  });

  const styles = StyleSheet.create({
    page: {
      display: 'flex',
      flexDirection: 'column',
      padding: 40,
      fontFamily: 'F Grotesk',
      color: '#0C3B49',
      fontSize: 16
    },
    rootView: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      textAlign: 'center'
    }
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.rootView}>{children}</View>
      </Page>
    </Document>
  );
}
